export default theme => ({
  root: {},
  backTitle: {},
  backTo: {
    marginLeft: theme.spacing(1),
    color: theme.palette.secondary.main,
  },
});
